export const errorMsg = (msg: string, err: any | undefined): string => {
  let statusCode = '';
  if (err) {
    const response = err.response;
    statusCode = response.status;
  }
  return `${msg} ${statusCode !== '' ? `has failed with status code ${statusCode}` : ''}`;
};
